/**
 * Opens the default mail client. The address is assembled at click time (not
 * one contiguous literal in JSX) so simple static HTML scrapers are less likely
 * to pick it up; the string still exists in the JS bundle for determined bots.
 */
export function openContactEmail(): void {
    const user = ['ja', 'son'].join('');
    const host = ['color', 'dodge', '.', 'com'].join('');
    const subject = encodeURIComponent('Hello from colordodge.com');
    window.location.assign(`mailto:${user}@${host}?subject=${subject}`);
}
